<template>
    <div class="modal-card" style="text-align: -webkit-center;">
        <header class="modal-card-head">
            <div class="model-icon icon-watchlist">
                <img src="/img/noun_Eye_2037671.svg">
            </div>
            <button
                type="button"
                class="delete"
                @click="$parent.close()"
            />
        </header>
        <section class="modal-card-body">
            <div class="card-content">
                <div class="has-text-weight-bold is-size-4-tablet mb-5">Add all funds to selected Watchlist</div>
                <div v-for="(i, index) in watchlists" :key="index" class="columns is-flex px-7 pt-0 pb-0">
                    <div class="column"><span class="is-size-6-tablet">{{i.name}}</span></div>
                    <b-radio v-model="watchlistId"
                        name="watchlistName"
                        :native-value="i.id">
                    </b-radio>
                </div>
                <div class="columns px-7 m-t-10">
                    <div class="column pr-0 pb-0">
                        <a @click="createNewClick" class="button is-secundary is-size-7">Create New</a>
                    </div>
                    <div class="column pl-0 pb-0">
                        <button @click="addFunds" class="button is-primary is-size-7">Add</button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import compositeMixin from "@/mixins/compositeMixin";
import axios from 'axios';
export default {
    name: "edit-watchlist-modal",
    mixins: [compositeMixin],
    data() {
        return {
            watchlists: null,
            watchlistId: null,
        }
    },
    mounted() {
        this.getWatchlists()
    },
    methods: {
        async getWatchlists() {
            await this.$store.dispatch("watchlist/getMyWatchlists")
            this.watchlists = this.$store.state.watchlist.myWatchlists;
        },
        
        async addFunsToWatchlistByID(watchlistId, fundIDs, ISINs) {
            try {
                let res = await axios.post(`/watchlist/multi-fund`, {
                            watchlist_id: watchlistId,
                            fund_ids: fundIDs, 
                            ISINs
                        })
                if(res.status === 200) {
                    this.$toast.success('Funds added successfully to watchlist!')
                    this.$parent.close();
                }
            } catch (error) {
                if(error.response.data.data.added) {
                    let fundText = error.response.data.data.added > 1 ? 'funds' : 'fund'
                    this.$toast.success(`${error.response.data.data.added} ${fundText} has been added successfully`)
                }
                this.$parent.close();
            }
            
        },
        async addFunds() {
            let fundIDs = [];
            let ISINs = [];
            let shortlist = this.$store.state.shortlist.fullshortlist
            shortlist.forEach(el=>{
                fundIDs.push(el.fund_id)
                ISINs.push(el.ISIN)
            })
            if(this.watchlistId) {
                let fundRes = await axios.post(`/watchlist/${this.watchlistId}`, {native: this.$store.state.search.currency})
                let funds = fundRes.data.data.items
                let fundsCanAdd = 20 - funds.length  
                if (fundsCanAdd==0) {
                    return this.$toast.error('The watchlist has reached 20 funds!')
                }
                if (fundsCanAdd > fundIDs.length) {
                    this.addFunsToWatchlistByID(this.watchlistId, fundIDs, ISINs)
                } else {
                    this.$buefy.dialog.confirm({
                        type: 'is-danger',
                        hasIcon: true,
                        cancelText: 'No',
                        confirmText: 'Yes',
                        message: 'The limit is reached for this watchlist, do you want to add to a different watchlist?',
                        onConfirm: () => {
                        },
                        onCancel: async () => {
                            this.addFunsToWatchlistByID(this.watchlistId, fundIDs, ISINs)
                        }
                    })
                }               
                    
                
            }
            else {
                this.$toast.error('Please select a Watchlist!')
            }
            
        },
        createNewClick() {
            let fundIDs = []
            let shortlist = this.$store.state.shortlist.fullshortlist
            shortlist.forEach(el=>{
                fundIDs.push(el.fund_id)
            })
            if (20 >= fundIDs.length) {
                this.$emit('update:createWatchlist', true)
            } else {
                this.$buefy.dialog.confirm({
                    type: 'is-danger',
                    hasIcon: true,
                    cancelText: 'No',
                    confirmText: 'Yes',
                    message: 'The limit is reached for this watchlist, do you want to add to a different watchlist?',
                    onConfirm: () => {
                    },
                    onCancel: async () => {
                        this.$emit('update:createWatchlist', true)
                    }
                })
            }
        }
    }
}
</script>

<style>

</style>